import React from 'react'
import SupportedResources from './SupportedResources/SupportedResources'
import SupportedSystemOperations from './SupportedSystemOperations/SupportedSystemOperations'

function SupportedCapabilities() {
    return (
        <section className='page-group supported-capabilities' id="supported-capabilities-section">
            <SupportedResources />
            {/* <SupportedSystemOperations/> */}
        </section>
    )
}

export default SupportedCapabilities